const applyProgramFinderQueries = (query, acceptedFacets) => {
  const isSelect = [
    'destinations',
    'field_prgm_lang_instruct',
    'field_prgm_disciplines',
  ];
  const multiValueSymbol = ';';
  const multiFilterSymbol = ' > ';

  Object.keys(query).forEach((key) => {
    const value = query[key];

    // Handle string values (radio buttons - single selection)
    if ((key === 'regions' || key === 'field_prgm_type') && acceptedFacets.hasOwnProperty(key) && value) {
      acceptedFacets[key] = value;
      return;
    }

    if (acceptedFacets.hasOwnProperty(key) && isSelect.includes(key) && value) {
      // Selects.
      if (key === 'destinations') {
        const destinations = value.split(multiValueSymbol);
        destinations.forEach((destination) => {
          if (destination.includes(multiFilterSymbol)) {
            acceptedFacets[key].push({
              label: `- ${destination.split(multiFilterSymbol)[1]}`,
              value: destination,
            });
          }
          else {
            acceptedFacets[key].push({
              label: destination,
              value: destination,
            });
          }
        });
      }
      else {
        value.split(multiValueSymbol).forEach((item) => {
          acceptedFacets[key].push({
            label: item,
            value: item,
          })
        });
      }
    }
    else if (acceptedFacets.hasOwnProperty(key) && value) {
      // Checkboxes.
      acceptedFacets[key] = value.split(multiValueSymbol);
    }
  });

  return acceptedFacets;
};

export default applyProgramFinderQueries;
